<script setup lang="ts">
import { CHART_ENGINE } from '@/shared/lib'

import AmChartsColumnChart from './AmChartsColumnChart.vue'
import ChartJsColumnChart from './ChartJsColumnChart.vue'
import type { ColumnChartProps } from './types'

/**
 * One series of vertical columns over a **category** axis — a value per bucket (per day),
 * where a single bucket still has to read as something.
 *
 * `LineChart` and not this one for a trend across time, or for several metrics: that one
 * spaces its points by how far apart they actually are. This one reads the x field as an
 * opaque label — pass it already formatted for display — and gives every column the same
 * width. It brings no legend: with a single series it would repeat the tooltip.
 *
 * Drawn by Chart.js or amCharts, whichever `CHART_ENGINE` names; until one of them goes, a
 * change of behaviour is made in both `ChartJsColumnChart.vue` and
 * `AmChartsColumnChart.vue`.
 */
defineProps<ColumnChartProps>()

const engine =
  CHART_ENGINE === 'amcharts' ? AmChartsColumnChart : ChartJsColumnChart
</script>

<template>
  <component :is="engine" v-bind="$props" />
</template>
